import request from '@/utils/request';

// 分销员列表
export const getAgentUserList = (data: any): any =>
  request({
    url: '/pc/member/memberPageList',
    data
  })

// 分销员详情
export const getAgentUserDetail = (data: any): any =>
  request({
    url: '/pc/member/memberInfo',
    data
  })
// 分销员编辑保存
// export const getAgentUserDetail = (data: any): any =>
//   request({
//     url: '/pc/member/memberInfo',
//     data
//   })

// 审核分销员状态
export const checkAgentUserState = (data: any): any =>
  request({
    url: '/agent/checkstate',
    data
  })

// 设置分销员信息#
export const setAgentCheckUserInfo = (data: any): any =>
  request({
    url: '/pc/member/saveMemberInfo',
    data
  })

// 分销员业绩统计
export const getAgentEarningsList = (data: any): any =>
  request({
    url: '/agent/earninglist',
    data
  })

// 分销员团队业绩
export const getTeamEarningsList = (data: any): any =>
  request({
    url: '/agent/team/earnings',
    data
  })

// 奖励业绩统计
export const getRewardEarningList = (data: any): any =>
  request({
    url: '/agent/reward/earnings',
    data
  })

// 获取分销员详细信息
export const getAgentUserInfo = (data: any): any =>
  request({
    url: '/pc/member/memberDetail',
    data
  })

// 分销员详情_奖励记录
export const getAgentRewardRecordList = (data: any): any =>
  request({
    url: '/pc/member/memberProfitRecord',
    data
  })

// 分销员详情_上级变更日志
export const getAgentUpperLogs = (data: any): any =>
  request({
    url: '/pc/member/memberChangeSuperRecord',
    data
  })

// 分销员详情_推荐人变更日志
export const getAgentInviteLogs = (data: any): any =>
  request({
    url: '/pc/member/memberChangeRecommendRecord',
    data
  })

// 分销员详情_等级变更日志
export const getAgentLevelLogs = (data: any): any =>
  request({
    url: '/pc/member/memberChangeRoleRecord',
    data
  })

// 分销员详情_业绩统计
export const getAgentEarningsStatistics = (data: any): any =>
  request({
    url: '/pc/member/memberPerformance',
    data
  })

// 拉黑分销员
export const setBlackMember = (data: any): any =>
  request({
    url: '/pc/member/memberPullBlack',
    data
  })

// 手机号查询授权通过代理信息
export const memberAuthInfoByPhone = (data: any): any =>
  request({
    url: '/pc/member/memberAuthInfoByPhone',
    data
  })

// 修改推荐人
export const changeRecommend = (data: any): any =>
  request({
    url: '/pc/member/changeRecommend',
    data
  })

// 审核会员
export const checkMembers = (data: any): any =>
  request({
    url: '/pc/member/memberCheck',
    data
  })

// 分销员业绩统计_详情
export const getAgentEarningsInfo = (data: any): any =>
  request({
    url: '/agent/earnings/info',
    data
  })

//添加分销员
export const addmember = (data: any): any =>
  request({
    url: '/pc/member/addmember',
    data
  })

// 商城装修
export const homeNavigationhomeNavigationSave = (data: any): any =>
  request({
    url: '/pc/homeNavigation/homeNavigationSave',
    data
  })

// 商城装修 保存
export const homeNavigationhomeNavigationInfo = (data: any): any =>
  request({
    url: '/pc/homeNavigation/homeNavigationInfo',
    data
  })

// 分销员列表修改信息
export const membersaveCustomerInfo = (data: any): any =>
  request({
    url: '/pc/member/saveCustomerInfo',
    data
  })
  // 考核配置信息
  export const relegationAssessmentConfigInit = (data: any): any =>
  request({
    url: '/pc/relegationAssessmentConfig/Init',
    data
  })
  // 考核配置修改
  export const relegationAssessmentConfigsave = (data: any): any =>
  request({
    url: '/pc/relegationAssessmentConfig/save',
    data
  })
  
  // 推荐业绩统计
  export const recommendPerformanceStatisticlist = (data: any): any =>
  request({
    url: '/pc/recommendPerformanceStatistic/list',
    data
  })
  // VIP取消授权
  export const membermemberCancelAuth = (data: any): any =>
  request({
    url: '/pc/member/memberCancelAuth',
    data
  })

  
  // 用户积分（积分管理）
  export const memberPointmemberList = (data: any): any =>
  request({
    url: '/pc/memberPoint/memberList',
    data
  })
  // 积分明细
  export const memberPointflowRecordList = (data: any): any =>
  request({
    url: '/pc/memberPoint/flowRecordList',
    data
  })
  
  // "邀请码统计列表
  export const memberRecommendNoStatisticslist = (data: any): any =>
  request({
    url: '/pc/memberRecommendNoStatistics/list',
    data
  })
  // "邀请码调整数量
  export const memberRecommendNoStatisticschange = (data: any): any =>
  request({
    url: '/pc/memberRecommendNoQuota/change',
    data
  })
  // "邀请码名额变动明细列表
  export const memberRecommendNoQuotaChangeRecordlist = (data: any): any =>
  request({
    url: '/pc/memberRecommendNoQuotaChangeRecord/list',
    data
  })
  // "分销员变动记录列表
  export const memberRecordlist = (data: any): any =>
  request({
    url: '/pc/memberRecord/list',
    data
  })

// 分享零售数据
export const shareAndRetailStatis = (data: any): any =>
  request({
    url: '/pc/member/shareAndRetailStatis',
    data
  })


